/* EclatDent — header : masquage au scroll, tiroir mobile, overlay recherche, badge panier */
(() => {
  if (window.__edhInit) return;
  window.__edhInit = true;

  const root = document.querySelector('[data-edh]');
  if (!root) return;

  // — Masquage à la descente, retour à la remontée + état "scrolled" —
  let lastY = window.scrollY, ticking = false;
  function onScroll() {
    ticking = false;
    const y = window.scrollY;
    root.classList.toggle('is-scrolled', y > 10);
    const drawerOpen = drawer && !drawer.hidden;
    if (!drawerOpen) {
      if (y > lastY && y > 140) root.classList.add('is-hidden');
      else root.classList.remove('is-hidden');
    }
    lastY = y;
  }
  addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(onScroll); } }, { passive: true });

  // — Tiroir mobile —
  const burger = root.querySelector('[data-edh-burger]');
  const drawer = root.querySelector('[data-edh-drawer]');
  onScroll();
  function setDrawer(open) {
    if (!drawer || !burger) return;
    drawer.hidden = !open;
    burger.setAttribute('aria-expanded', String(open));
    // 03/11 (point 16) : libellés traduits (avant : français en dur sur les 5 langues)
    burger.setAttribute('aria-label', (open ? burger.dataset.labelClose : burger.dataset.labelOpen) || burger.getAttribute('aria-label'));
    document.documentElement.classList.toggle('edh-lock', open);
    if (open) root.classList.remove('is-hidden');
  }
  if (burger && drawer) {
    burger.addEventListener('click', () => setDrawer(drawer.hidden));
    drawer.addEventListener('click', (e) => {
      if (e.target instanceof Element && e.target.closest('a')) setDrawer(false);
    });
  }

  // — Overlay recherche —
  const search = root.querySelector('[data-edh-search]');
  const searchInput = root.querySelector('[data-edh-search-input]');
  function setSearch(open) {
    if (!search) return;
    search.hidden = !open;
    document.documentElement.classList.toggle('edh-lock', open);
    if (open && searchInput) setTimeout(() => searchInput.focus(), 30);
  }
  root.querySelectorAll('[data-edh-search-open]').forEach((b) => b.addEventListener('click', () => { setDrawer(false); setSearch(true); }));
  root.querySelectorAll('[data-edh-search-close]').forEach((b) => b.addEventListener('click', () => setSearch(false)));
  if (search) search.addEventListener('click', (e) => { if (e.target === search) setSearch(false); });
  addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    if (search && !search.hidden) setSearch(false);
    else if (drawer && !drawer.hidden) setDrawer(false);
  });

  // — Badge panier : rendu par Liquid, rafraîchi sur cart:refresh (nos ajouts AJAX) et au retour bfcache —
  const count = root.querySelector('[data-edh-count]');
  function refreshCount() {
    if (!count) return;
    fetch('/cart.js').then((r) => r.json()).then((cart) => {
      const n = cart.item_count || 0;
      count.textContent = String(n);
      count.hidden = n === 0;
      count.classList.add('pop');
      setTimeout(() => count.classList.remove('pop'), 250);
    }).catch(() => {});
  }
  document.addEventListener('cart:refresh', refreshCount);
  addEventListener('pageshow', (e) => { if (e.persisted) refreshCount(); });

  // — 03/11/2026 (point 11) : recherche instantanée, produits et articles avec images (API /search/suggest de Shopify) —
  const sugg = root.querySelector('[data-edh-suggest]');
  if (search && searchInput && sugg && search.dataset.suggestUrl) {
    const D = search.dataset;
    const esc = (t) => String(t == null ? '' : t).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
    const vignette = (u) => (u ? u + (u.includes('?') ? '&' : '?') + 'width=96' : '');
    const cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
    const prix = (p) => { const n = Number(p); if (!isFinite(n) || n <= 0) return ''; try { return new Intl.NumberFormat(document.documentElement.lang || 'fr', { style: 'currency', currency: cur }).format(n); } catch (e) { return n.toFixed(2); } };
    const ligne = (o, sous) => {
      const img = (o.featured_image && o.featured_image.url) || o.image || '';
      return '<a class="edh-sg-item" href="' + esc(o.url) + '">' +
        (img ? '<img src="' + esc(vignette(img)) + '" alt="" width="48" height="48" loading="lazy">' : '<span class="edh-sg-ph" aria-hidden="true"></span>') +
        '<span class="edh-sg-t">' + esc(o.title) + '</span>' + (sous ? '<span class="edh-sg-p">' + esc(sous) + '</span>' : '') + '</a>';
    };
    let minuterie, ctrl;
    const chercher = () => {
      const q = searchInput.value.trim();
      if (ctrl) ctrl.abort();
      if (q.length < 2) { sugg.innerHTML = ''; return; }
      ctrl = 'AbortController' in window ? new AbortController() : null;
      const url = D.suggestUrl + '.json?q=' + encodeURIComponent(q) + '&resources[type]=product,article&resources[limit]=6&resources[limit_scope]=each&resources[options][unavailable_products]=last';
      fetch(url, { signal: ctrl ? ctrl.signal : undefined, headers: { Accept: 'application/json' } })
        .then((r) => (r.ok ? r.json() : Promise.reject(r.status)))
        .then((j) => {
          const res = (j && j.resources && j.resources.results) || {};
          const prods = res.products || [], arts = res.articles || [];
          if (!prods.length && !arts.length) { sugg.innerHTML = '<p class="edh-sg-none">' + esc(D.tNone) + '</p>'; return; }
          let h = '';
          if (prods.length) h += '<div class="edh-sg-col"><p class="edh-sg-h">' + esc(D.tProducts) + '</p>' + prods.map((p) => ligne(p, prix(p.price))).join('') + '</div>';
          if (arts.length) h += '<div class="edh-sg-col"><p class="edh-sg-h">' + esc(D.tArticles) + '</p>' + arts.map((a) => ligne(a, '')).join('') + '</div>';
          const form = search.querySelector('form');
          const tout = (form ? form.getAttribute('action') : '/search') + '?q=' + encodeURIComponent(q);
          h += '<a class="edh-sg-all" href="' + esc(tout) + '">' + esc(D.tAll) + ' →</a>';
          sugg.innerHTML = h;
        })
        .catch(() => {});
    };
    searchInput.addEventListener('input', () => { clearTimeout(minuterie); minuterie = setTimeout(chercher, 220); });
  }
})();

// — 03/11/2026 (point 24) : bouton « retour en haut » discret, après deux écrans de défilement (markup : ed-footer) —
(() => {
  const btn = document.querySelector('[data-ed-haut]');
  if (!btn) return;
  let tic = false;
  const maj = () => { tic = false; btn.classList.toggle('is-on', window.scrollY > innerHeight * 2); };
  addEventListener('scroll', () => { if (!tic) { tic = true; requestAnimationFrame(maj); } }, { passive: true });
  btn.addEventListener('click', () => {
    const doux = !matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: 0, behavior: doux ? 'smooth' : 'auto' });
    const cible = document.getElementById('MainContent');
    if (cible) { cible.setAttribute('tabindex', '-1'); cible.focus({ preventScroll: true }); }
  });
})();
